const baseUrl = 'https://apibackend.bellazamodo.shop';

function getCollectionHandle() {
  const quizSection = document.querySelector('.quiz-banner-section');
  if (quizSection) {
    const settingsHandle = quizSection.getAttribute('data-quiz-collection-handle');
    if (settingsHandle && settingsHandle.trim() !== '') {
      return settingsHandle.trim();
    }
  }
  
  return null;
}

function handleQuizButtonClick(event) {
  event.preventDefault();
  
  // Track quiz started event in CleverTap
  if (typeof window.trackQuizStarted === 'function') {
    const currentCollectionHandle = getCollectionHandle();
    window.trackQuizStarted({
      quiz_id: currentCollectionHandle || '',
      quiz_title: 'Product Quiz',
      source: 'collection_quiz_banner'
    });
  }
  
  // Check if user is logged in
  const isLoggedIn = checkUserLoggedIn();
  
  // if (!isLoggedIn) {
  //   // User is not logged in, open login dialog
  //   openLoginDialog();
  //   return;
  // }
  
  // User is logged in, proceed with quiz
  const currentCollectionHandle = getCollectionHandle();
  
  if (!currentCollectionHandle) {
    console.error('No collection selected for quiz');
    alert('Please select a collection in the section settings to enable the quiz.');
    return;
  }
  
  sessionStorage.setItem('quizOriginalCollectionHandle', currentCollectionHandle);
  try { localStorage.setItem('quizOriginalCollectionHandle', currentCollectionHandle); } catch(e) {}
  
  triggerFirstQuizAPI(currentCollectionHandle);
}

// Check if user is logged in
function checkUserLoggedIn() {
  try {
    // Method 1: Check Kwikpass token
    if (typeof getValueFromCookiesOrLocalStorage === 'function' && 
        typeof XGokwikCoreToken === 'function' && 
        typeof window.merchantInfo !== 'undefined') {
      const token = getValueFromCookiesOrLocalStorage(XGokwikCoreToken(window.merchantInfo.environment));
      if (token) {
        return true;
      }
    }
    
    // Method 2: Check KWIKSESSIONTOKEN
    const kwikToken = localStorage.getItem('KWIKSESSIONTOKEN');
    if (kwikToken) {
      return true;
    }
    
    // Method 3: Check kp_customer_id
    const customerId = (() => {
      try {
        return (
          localStorage.getItem("kp_customer_id") ||
          localStorage.getItem("dummy-customerid") ||
          null
        );
      } catch (_) {
        return null;
      }
    })();

    if (customerId) {
      return true;
    }
    
    // Method 4: Check Shopify customer object
    if (typeof window.customer !== 'undefined' && window.customer && window.customer.id) {
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Error checking login status:', error);
    return false;
  }
}

// Open login dialog
function openLoginDialog() {
  try {
    // Method 1: Use Kwikpass handleKpAndShopifyLogin if available
    if (typeof handleKpAndShopifyLogin === 'function') {
      handleKpAndShopifyLogin(window.location.pathname);
      return;
    }
    
    // Method 2: Use Kwikpass handleShopifyLogin if available
    if (typeof handleShopifyLogin === 'function') {
      handleShopifyLogin(event, window.location.pathname);
      return;
    }
    
    // Method 3: Use openIframe if available
    if (typeof openIframe === 'function') {
      openIframe('kp_sso_token');
      return;
    }
    
    // Method 4: Fallback to Shopify login page
    window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
  } catch (error) {
    console.error('Error opening login dialog:', error);
    // Final fallback
    window.location.href = '/account/login';
  }
}

async function triggerFirstQuizAPI(collectionHandle) {
  if (!collectionHandle) return;
  
  try {
    const customerId = (() => {
      try {
        return (
          localStorage.getItem("kp_customer_id") ||
          localStorage.getItem("dummy-customerid") ||
          null
        );
      } catch (_) {
        return null;
      }
    })();

    
    const response = await fetch(`${baseUrl}/api/quiz`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'any'
      },
      body: JSON.stringify({
        collectionHandle: collectionHandle,
        customerId: customerId
      })
    });
    
    const jsonData = await response.json();
    const data = jsonData.data;
    console.log('First Quiz API Response:', data);
    const customerId1 = data?.sessionInfo?.customerId;
    console.log('Received customerId from API:', customerId1);
    if (customerId1) {
        localStorage.setItem("dummy-customerid", customerId1);
    }
    console.log('Stored cerustomId in localStorage:', customerId1);
    const showExistingRecommendation = data.showExistingRecommendation;
    const quizCompleted = data.quizCompleted;
    
    sessionStorage.setItem('quizResultsData', JSON.stringify(data.recommendations));
    sessionStorage.setItem('quizCollectionHandle', getCollectionHandle());
    
    if(showExistingRecommendation && quizCompleted) {
        sessionStorage.setItem('recomendedProducts', JSON.stringify(data.recommendations));
        sessionStorage.setItem('totalRecommendations', data.totalRecommendations || (data.recommendations ? data.recommendations.length : 0));
        sessionStorage.setItem('showExistingRecommendation', 'true');
        sessionStorage.setItem('quizCompleted', 'true');
        
        // Track showing existing results
        if (typeof window.trackQuizSubmitted === 'function') {
          window.trackQuizSubmitted({
            quiz_id: collectionHandle || '',
            quiz_title: 'Product Quiz',
            source: 'existing_results'
          });
        }
        
        window.location.href = '/pages/quiz';
    } else {
        sessionStorage.setItem('quizData', JSON.stringify(data));
        sessionStorage.setItem('quizSessionId', data.sessionInfo.sessionId);
        sessionStorage.setItem('showExistingRecommendation', 'false');
        sessionStorage.setItem('quizCompleted', 'false');
        sessionStorage.setItem('quizQuestions', JSON.stringify(data.questions));
        sessionStorage.setItem('quizTotalQuestions', data.totalQuestions);
        
        // Track first question viewed
        if (data.questions && data.questions.length > 0 && typeof window.trackQuizQuestionViewed === 'function') {
          const firstQuestion = data.questions[0];
          window.trackQuizQuestionViewed({
            quiz_id: collectionHandle || '',
            quiz_title: 'Product Quiz',
            source: 'quiz_flow',
            question_id: firstQuestion.id || 'q1',
            question_number: 1
          });
        }
        
        window.location.href = '/pages/quiz';
    }

  } catch (error) {
    console.error('Error loading quiz:', error);
  }
}

let quizSessionId = null;
let currentQuestionIndex = 0;

async function quizSelectOption(questionId, optionIds, isSelected = true , action = null) {
  try {
    const collectionHandle = sessionStorage.getItem('quizCollectionHandle');
    const customerId = (() => {
      try {
        return (
          localStorage.getItem("kp_customer_id") ||
          localStorage.getItem("dummy-customerid") ||
          null
        );
      } catch (_) {
        return null;
      }
    })();


    const requestBody = {
      collectionHandle: collectionHandle,
      customerId: customerId,
      action: action
    };

    if (action === 'update_answers') {
      if (questionId && optionIds) {
        const ids = Array.isArray(optionIds) ? optionIds : [optionIds];
        requestBody.questionsData = [{
          questionId: questionId,
          selectedOptions: ids
        }];
      } else {
        const storedAnswers = JSON.parse(sessionStorage.getItem('quizAnswers') || '{}');
        requestBody.questionsData = Object.keys(storedAnswers).map(qId => ({
          questionId: qId,
          selectedOptions: storedAnswers[qId]
        }));
      }
    }
    
    const response = await fetch(`${baseUrl}/api/quiz/update`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      },
      body: JSON.stringify(requestBody)
    });
    const data = await response.json();
    
    if (data && data.success === true) {
     // console.log('quizSelectOption success:', data);
      return data;
    } else {
      console.error('quizSelectOption failed:', data);
      return null;
    }
  } catch (e) {
    console.error('quizSelectOption failed', e);
    return null;
  }
}

async function quizGetQuestion(index, questionId = null, selectedOptions = null, action = null) {
  try {
    const payload = {
      sessionId: quizSessionId,
      currentQuestionIndex: index
    };
    
    if (questionId && selectedOptions) {
      payload.questionId = questionId;
      payload.selectedOptions = selectedOptions;
    }
    
    if (action) {
      payload.action = action;
    }
    
    const response = await fetch(`${baseUrl}/api/quiz/question`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    console.log('quizGetQuestion response:', data);
    if (data && data.success === true) {
      return data;
    } else {
      console.error('quizGetQuestion failed:', data);
      return null;
    }
  } catch (e) {
    console.error('quizGetQuestion failed', e);
    return null;
  }
}

async function saveAnswersToServer() {
  try {
    const storedAnswers = JSON.parse(sessionStorage.getItem('quizAnswers') || '{}');
    if (Object.keys(storedAnswers).length === 0) {
      return { success: true, message: 'No answers to save' };
    }
    
    const collectionHandle = sessionStorage.getItem('quizCollectionHandle');
    const customerId = (() => {
      try {
        return (
          localStorage.getItem("kp_customer_id") ||
          localStorage.getItem("dummy-customerid") ||
          null
        );
      } catch (_) {
        return null;
      }
    })();


    const questionsData = Object.keys(storedAnswers).map(qId => ({
      questionId: qId,
      selectedOptions: storedAnswers[qId]
    }));

    const response = await fetch(`${baseUrl}/api/quiz/update`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      },
      body: JSON.stringify({
        collectionHandle: collectionHandle,
        customerId: customerId,
        action: 'update_answers',
        questionsData: questionsData
      })
    });
    
    const data = await response.json();
    return data;
  } catch (e) {
    console.error('Failed to save answers to server:', e);
    return { success: false, error: e.message };
  }
}

async function startQuiz() {
  try {
    const storedSessionId = sessionStorage.getItem('quizSessionId');
    const currentQuestionIndex = parseInt(sessionStorage.getItem('quizCurrentIndex')) || 0;
    
    if (storedSessionId && window.quizApi && window.quizApi.setSessionId) {
      window.quizApi.setSessionId(storedSessionId);
    }
    
    const quizData = JSON.parse(sessionStorage.getItem('quizData'));
    
    if (quizData && quizData.questions) {
      // Track quiz question viewed
      const collectionHandle = sessionStorage.getItem('quizCollectionHandle');
      if (quizData.questions[currentQuestionIndex] && typeof window.trackQuizQuestionViewed === 'function') {
        const currentQuestion = quizData.questions[currentQuestionIndex];
        window.trackQuizQuestionViewed({
          quiz_id: collectionHandle || '',
          quiz_title: 'Product Quiz',
          source: 'quiz_flow',
          question_id: currentQuestion.id || `q${currentQuestionIndex + 1}`,
          question_number: currentQuestionIndex + 1
        });
      }
      
      const event = new CustomEvent('quiz:loaded', { detail: quizData });
      window.dispatchEvent(event);
    } else {
      console.error('No quiz data found in session storage');
    }
  } catch (error) {
    console.error('Error starting quiz:', error);
  }
}

async function autoTriggerQuiz() {
  const currentPath = window.location.pathname;
  
  if (currentPath === '/pages/quiz') {
    const quizCompleted = sessionStorage.getItem('quizCompleted') === 'true';
    const showExistingRecommendation = sessionStorage.getItem('showExistingRecommendation') === 'true';
    
    if (quizCompleted && showExistingRecommendation) {
      try {
        const recomendedProducts = JSON.parse(sessionStorage.getItem('recomendedProducts') || '[]');
        const totalRecommendations = parseInt(sessionStorage.getItem('totalRecommendations')) || recomendedProducts.length;
        
        const evt = new CustomEvent('quiz:results', { 
          detail: { 
            success: true, 
            data: { 
              recommendations: recomendedProducts,
              totalRecommendations: totalRecommendations
            } 
          } 
        });
        window.dispatchEvent(evt);
        return; 
      } catch(e) {
        console.error('Error loading existing recommendations:', e);
      }
    }
    
    try {
      const resultsRaw = sessionStorage.getItem('quizResultsData');
      
      if (resultsRaw) {
        const resultsData = JSON.parse(resultsRaw);
        const evt = new CustomEvent('quiz:results', { detail: { success: true, data: resultsData } });
        window.dispatchEvent(evt);
        sessionStorage.removeItem('quizResultsData');
        return; 
      }
    } catch(e) { }
    
    await startQuiz();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  autoTriggerQuiz();
  
  if (document.querySelector('.quiz-banner-section')) {
    const quizButtons = document.querySelectorAll('.quiz-banner-button');
    quizButtons.forEach(button => {
      button.addEventListener('click', handleQuizButtonClick);
    });
  }
});

window.quizApi = {
  selectOption: quizSelectOption,
  getQuestion: quizGetQuestion,
  saveAnswers: saveAnswersToServer,
  setSessionId: (id) => { quizSessionId = id; },
  setCurrentIndex: (idx) => { currentQuestionIndex = idx; },
  trackQuestionViewed: (questionData) => {
    if (typeof window.trackQuizQuestionViewed === 'function') {
      const collectionHandle = sessionStorage.getItem('quizCollectionHandle');
      window.trackQuizQuestionViewed({
        quiz_id: collectionHandle || '',
        quiz_title: 'Product Quiz',
        source: 'quiz_flow',
        question_id: questionData.question_id || '',
        question_number: questionData.question_number || 0
      });
    }
  },
  trackQuizExited: (currentQuestionNumber) => {
    if (typeof window.trackQuizExited === 'function') {
      const collectionHandle = sessionStorage.getItem('quizCollectionHandle');
      window.trackQuizExited({
        quiz_id: collectionHandle || '',
        quiz_title: 'Product Quiz',
        source: 'quiz_flow',
        current_question_number: currentQuestionNumber || 0
      });
    }
  },
  trackQuizSubmitted: () => {
    if (typeof window.trackQuizSubmitted === 'function') {
      const collectionHandle = sessionStorage.getItem('quizCollectionHandle');
      window.trackQuizSubmitted({
        quiz_id: collectionHandle || '',
        quiz_title: 'Product Quiz',
        source: 'quiz_flow'
      });
    }
  }
};

window.addAllRecommendedToCart = addAllRecommendedToCart;

async function addAllRecommendedToCart() {
  
  try {
    let recommendedProducts = JSON.parse(sessionStorage.getItem('recomendedProducts') || '[]');
    
    if (!recommendedProducts || recommendedProducts.length === 0) {
      console.warn('No recommended products found in sessionStorage');
      alert('No recommended products to add to cart. Please retake the quiz.');
      return false;
    }
    
    const cartItems = [];
    for (const product of recommendedProducts) {
      let variantId = null;
      
      if (product.variantId) {
        variantId = parseInt(product.variantId);
      }
      
      if (!variantId && product.productId && typeof product.productId === 'string') {
        let match = product.productId.match(/gid:\/\/shopify\/ProductVariant\/(\d+)/);
        if (match) {
          variantId = parseInt(match[1]);
        } else {
          match = product.productId.match(/gid:\/\/shopify\/Product\/(\d+)/);
          const productId = match ? match[1] : null;
          
          if (productId) {
            const productElement = document.querySelector(`[data-product-id="${productId}"]`);
            if (productElement) {
              const addToCartBtn = productElement.querySelector('.add-to-cart[data-product]');
              if (addToCartBtn) {
                try {
                  const productData = JSON.parse(addToCartBtn.getAttribute('data-product').replace(/&quot;/g, '"'));
                  if (productData.variant_id) {
                    variantId = parseInt(productData.variant_id);
                  }
                } catch (error) {
                  console.warn(`Failed to parse product data for product ${productId}:`, error);
                }
              }
            }
          }
        }
      }
      
      if (variantId && variantId > 0) {
        cartItems.push({
          id: variantId,
          quantity: 1
        });
      } else {
        console.warn('Could not extract variant ID from:', product);
      }
    }
    
    if (cartItems.length === 0) {
      console.warn('No valid variant IDs found');
      alert('Unable to add products to cart. Please try again.');
      return false;
    }
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        items: cartItems
      })
    });
    
    if (!response.ok) {
      throw new Error(`Failed to add products to cart: ${response.status}`);
    }
    
    const result = await response.json();
    
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        cart: result,
        products: cartItems
      }
    }));
    
    try {
      const cartData = await window.theme.cartStore.refresh();
      
      const cartBubbles = document.querySelectorAll('.cart-link__bubble, .your-cart-count');
      cartBubbles.forEach(bubble => {
        bubble.textContent = cartData.item_count;
      });
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cartData }
      }));
    } catch (e) {
      console.warn('Could not update cart count:', e);
    }
    
    openCartDrawer();
    
    return true;
  } catch (error) {
    console.error('Error adding products to cart:', error);
    alert('Failed to add products to cart. Please try again.');
    return false;
  }
}

function openCartDrawer() {
  try {
    document.dispatchEvent(new CustomEvent('cart:open'));
  } catch (e) {
    console.warn('Method 1 failed:', e);
  }
  
  try {
    if (window.theme && window.theme.CartDrawer) {
      const cartDrawer = new window.theme.CartDrawer();
      cartDrawer.open();
    }
  } catch (e) {
    console.warn('Method 2 failed:', e);
  }
  
  try {
    const cartIcon = document.querySelector('.js-drawer-open-cart');
    if (cartIcon) {
      cartIcon.click();
    }
  } catch (e) {
    console.warn('Method 3 failed:', e);
  }
  
  try {
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      cartDrawer.classList.add('js-drawer-open');
    }
  } catch (e) {
    console.warn('Method 4 failed:', e);
  }
}

if (document.readyState !== 'loading') {
  try { autoTriggerQuiz(); } catch(e) { }
}